package io.horion.cv.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.forms.SelectFormField
import io.horion.cv.components.widgets.AlertMessage
import io.horion.cv.components.widgets.FormRow
import io.horion.cv.components.widgets.RichTextArea
import io.horion.cv.components.widgets.TextDescription
import io.horion.cv.components.widgets.TextFormFieldWhite
import io.horion.cv.components.widgets.ToastType
import io.horion.cv.components.widgets.useToast
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.styles.LogoStyle
import io.horion.cv.styles.TextDescriptionFormStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Composable
fun ApplyJobModal(
    onDismiss: () -> Unit,
    isMobile: Boolean = false,
    onClick: () -> Unit,
    cvList: List<String> = listOf("CV 1", "CV 2", "CV 3")
) {
    val breakpoint = rememberBreakpoint()
    val ctx = rememberPageContext()

    Box(
        modifier = Modifier
            .fillMaxSize()
            .styleModifier {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("z-index", "1100")
                property("background-color", "rgba(0,0,0,0.3)")
            }
            .onClick { onDismiss() }
    ) {
        // Drawer à droite
        Box(
            modifier = Modifier
                .styleModifier {
                    property("position", "fixed")
                    property("top", "0")
                    property("right", "0")
                    property("height", "100vh")
                    property("width", if (isMobile) "100vw" else "50vw")
                    property("background", "white")
                    property("box-shadow", "-4px 0 20px rgba(0,0,0,0.2)")
                    property("animation", "slideInRight 0.3s ease")
                }
                .padding(if (isMobile) 16.px else 32.px)
                .onClick { it.stopPropagation() }
        ) {
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.SpaceBetween
            ) {
                // En-tête avec le titre et la fermeture
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(){
                        Image(
                            src = "/logo.png",
                            description = "CV Logo",
                            modifier = LogoStyle.toModifier()
                                .size(if (breakpoint <= Breakpoint.MD) 20.px else 24.px)
                                .margin(bottom = 24.px)
                        )
                        SpanText(
                            "Postuler",
                            modifier = Modifier
                                .fontSize(if (isMobile) 20.px else 24.px)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    // Bouton de fermeture
                    Button(
                        onClick = { onDismiss() },
                        modifier = Modifier
                            .size(if (isMobile) 30.px else 36.px)
                            .backgroundColor(Colors.LightGray)
                            .borderRadius(50.px)
                    ) {
                        SpanText("✕", modifier = Modifier.fontSize(if (isMobile) 16.px else 20.px))
                    }
                }

               /* Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(1.px)
                        .backgroundColor(Colors.LightGray)
                )*/

                // Contenu centré
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(20.px),
                    verticalArrangement = Arrangement.spacedBy(20.px)
                ) {
                    // Section CV
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.spacedBy(8.px)
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            SpanText(
                                text = "CV",
                                modifier = Modifier
                                    .fontSize(if (breakpoint <= Breakpoint.MD) 14.px else 16.px)
                                    .fontWeight(FontWeight.Medium)
                                    .color(Colors.Black)
                            )
                            SelectFormField(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .margin(leftRight = 20.px)
                                    .border(1.px,LineStyle.Solid, Colors.Black),
                                label = "",
                                options = cvList,
                                defaultValue = if (cvList.isNotEmpty()) cvList.first() else "Choisir un cv",
                                onValueChange = { valeur ->
                                    // Traiter la sélection
                                }
                            )
                            SpanText(
                                text = "Créer un CV",
                                modifier = Modifier
                                    .fontSize(if (breakpoint <= Breakpoint.MD) 12.px else 14.px)
                                    .color(Colors.Blue)
                                    .cursor(Cursor.Pointer)
                                    .onClick { ctx.router.navigateTo(Screen.CV.path) }
                            )
                        }


                    }

                    // Section Lettre de motivation
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.spacedBy(8.px)
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            SpanText(
                                text = "Lettre de motivation",
                                modifier = Modifier
                                    .fontSize(if (breakpoint <= Breakpoint.MD) 14.px else 16.px)
                                    .fontWeight(FontWeight.Medium)
                                    .color(Colors.Black)
                            )

                                SpanText(
                                    text = "Créer une lettre",
                                    modifier = Modifier
                                        .fontSize(if (breakpoint <= Breakpoint.MD) 12.px else 14.px)
                                        .color(Colors.Blue)
                                        .cursor(Cursor.Pointer)
                                        .onClick {ctx.router.navigateTo("/motivation") }
                                )

                        }

                        TextDescription(
                            label = "",
                            value = "",
                            onValueChange = {},
                            isMobile = breakpoint < Breakpoint.SM,
                            isTablet = breakpoint >= Breakpoint.SM && breakpoint < Breakpoint.MD,
                            modifier = TextDescriptionFormStyle.toModifier()
                        )
                    }
                }

                // Boutons en bas (gauche et droite)
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(top = 24.px),
                    horizontalArrangement = Arrangement.SpaceBetween,
                ) {
                    // Bouton "annuler" à gauche
                   Button(
                        onClick = { onDismiss() },
                        modifier = Modifier
                            .height(44.px)
                            .backgroundColor(Colors.LightGray)
                            .borderRadius(8.px)
                            .styleModifier {
                                property("cursor", "pointer")
                                property("transition", "all 0.2s ease")
                            }
                    ) {
                        SpanText("Annuler",
                            modifier = Modifier
                                .color(Colors.Black)
                                .fontWeight(FontWeight.Medium)
                        )
                    }
                    // Bouton "Envoyer ma candidature" à droite
                    Button(
                        onClick = {
                            onClick()
                            onDismiss()
                        },
                        modifier = Modifier
                            .width(if (isMobile) 150.px else 230.px)
                            .height(if (isMobile) 40.px else 48.px)
                            .backgroundColor(Colors.LighterBlue)
                            .borderRadius(8.px)
                    ) {
                        SpanText(
                            "Envoyer ma candidature",
                            modifier = Modifier
                                .color(Colors.White)
                                .fontWeight(FontWeight.SemiBold)
                                .fontSize(if (isMobile) 12.px else 18.px)
                        )
                    }
                }
            }
        }
    }
}